<template>
  <div class="method-stripe">
    <b-input-group prepend="$" class="mb-1">
      <b-form-input
        :placeholder="`Enter Amount ${limits.min}$ - ${limits.max}$`"
        type="number"
        v-model="amount"
      />
    </b-input-group>
    <p class="text-left">
      <strong>Invoice:</strong> you will receive your tax invoice by email right after payment.<br /><br />
      <span v-if="amount > 0">
        Total: <strong>{{ totalAmount }} $</strong>
      </span>
    </p>
    <div class="text-error" v-if="amountValue > 0 && amountValue < limits.min">
      Can't pay less than {{ limits.min }}$
    </div>
    <div class="text-error" v-if="amountValue > limits.max">
      Can't pay more than {{ limits.max }}$
    </div>
    <StripeCheckout
      v-show="amountValue >= limits.min && amountValue <= limits.max"
      :amount="totalAmount"
    />
  </div>
</template>

<script>
import StripeCheckout from "@/components/util/Stripe/StripeCheckout.vue";
import { BInputGroup, BFormInput } from "bootstrap-vue";
import { mapMutations } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
  props: ["between"],
  data: () => ({
    amount: "",
    // 2026-07: fee absorbed by seller (same as Revolut). Backend
    // stripeCreateSession no longer divides by 1.02. Restore fee: 2 there
    // and here together if passthrough ever comes back.
    fee: 0,
  }),
  methods: {
    ...mapMutations(["HANDLE_CREDIT"]),
    complete(amount) {
      this.HANDLE_CREDIT(+amount);
      // notify
      this.$toast({
        component: ToastificationContent,
        props: {
          title: `Deposit Made`,
          icon: "CheckIcon",
          text: `You have deposit ${amount}$`,
          variant: "success",
        },
      });
    },
  },
  computed: {
    limits() {
      // Stripe (instant) limits
      return { min: 5, max: 500 };
    },
    amountValue() {
      return Number(this.amount) || 0;
    },
    totalAmount() {
      return Number(
        this.amountValue + this.amountValue * (this.fee / 100)
      ).toFixed(2);
    },
  },
  components: {
    StripeCheckout,
    BInputGroup,
    BFormInput,
    ToastificationContent,
  },
};
</script>

<style>
#stripe-element-errors {
  color: #f44336;
  font-size: 18px;
  margin-top: 10px;
}
</style>
